import { useCallback, useState } from 'react'
import { api } from '../services/api'
import { Card, CardType, Faction, Rarity } from '../types'

export function useCards() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [cards, setCards] = useState<Card[]>([])
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0, totalPages: 0 })

  const fetchCards = useCallback(async (params?: {
    search?: string
    type?: CardType | 'ALL'
    faction?: Faction | 'ALL'
    rarity?: Rarity | 'ALL'
    costMin?: number
    costMax?: number
    page?: number
    limit?: number
  }) => {
    setIsLoading(true)
    setError(null)
    try {
      const response = await api.getCards(params)
      if (response.success) {
        setCards(response.data)
        if (response.pagination) {
          setPagination({
            page: response.pagination.page,
            limit: response.pagination.limit,
            total: response.pagination.total,
            totalPages: response.pagination.totalPages
          })
        }
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar cartas')
    } finally {
      setIsLoading(false)
    }
  }, [])

  const getCard = useCallback(async (id: string) => {
    setIsLoading(true)
    setError(null)
    try {
      const response = await api.getCard(id)
      return response.data
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar carta')
      return null
    } finally {
      setIsLoading(false)
    }
  }, [])

  return {
    cards,
    isLoading,
    error,
    pagination,
    fetchCards,
    getCard,
    refreshCards: fetchCards,
  }
}
